/**
 * Gets the affiliate ID from the session token.
 * @param {string} accessToken - The (JWT) access token
 * @returns {string} The affiliate ID
 * @throws {Error} If the access token is invalid or if the affiliate ID is not found.
 */
export const getAffiliateId = async (
  accessToken: string,
): Promise<string | null> => {
  if (typeof accessToken !== "string") {
    throw new Error("Access token is required");
  }

  // [0] Header
  // [1] Payload
  // [2] Signature
  const payload = accessToken.split(".")[1] ?? "";

  const decode = (payload: string): any => {
    try {
      return JSON.parse(atob(payload));
    } catch (error) {
      console.error("Failed to parse JWT payload: ", error);
      throw new Error("Failed to parse JWT payload");
    }
  };

  const payloadDecoded = decode(payload);
  if (!payloadDecoded) {
    throw new Error("Failed to decode payload from access token");
  }

  const affiliateIds: string[] | undefined = payloadDecoded.organization;
  if (!affiliateIds) {
    throw new Error(
      "Failed to get affiliate IDs ('organization') from payload",
    );
  }

  if (affiliateIds.length === 0) {
    throw new Error("User has no affiliates");
  }

  if (affiliateIds.length > 1) {
    throw new Error("User has multiple affiliates, this is not supported yet");
  }

  return affiliateIds[0];
};
